<div class="card">
  <!-- Header Section -->
  <div class="card-header">
      <h4>Lead Report</h4>
  </div>

  <!-- Body Section -->
  <div class="card-body">
      <!-- Quick Filters and Column Dropdown -->
      <div class="row mb-2">
          <!-- Quick Filters -->
          <div *ngIf="quickFilterShow" class="col-md-12 mb-3">
              <!-- Quick Filter Inputs -->
              <div class="card">
                  <div class="card-body">
                      <div class="row">
                          <div class="col-md-4">
                              <label class="col-form-label">Search by Mobile Number</label>
                              <input [(ngModel)]="searchMerName" class="form-control" maxlength="10" id="searchMerName"  type="text" autocomplete="new-password" />
                          </div>
                          <div class="col-md-4">
                              <label class="col-form-label" >Search by Email Id</label>
                              <input [(ngModel)]="searchMID" class="form-control" maxlength="50" id="searchMerName"  type="text" autocomplete="new-password" />
                          </div>
                      
                      <div class="mb-3 col-md-2" style="margin-top: 3%;">
                        <!-- <div class="row"> -->
                        <!-- <div class="col-md-12"> -->
                        <!-- <label class="col-form-label" for="searchMID">Search</label> -->
                        <!-- </div>            -->
                        <!-- <div class="col-md-6"> -->
                        <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom" type="button"><i
                            class="feather icon-search"></i>Search
                        </button>
                        <!-- </div> -->
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
              </div>
          </div>

          <!-- Column Dropdown -->
          <div class="col-xl-10">
              <!-- Export and Quick Filter Buttons -->
              <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">Export Excel<i class="feather icon-download"></i></button>
              <button type="button" class="btn bg-danger-custom" (click)="quickFilterShowAction($event)">Quick Filters<i class="feather icon-filter"></i></button>
              <div class="btn-group mb-1 mb-md-0">
                  <div class="btn-group" ngbDropdown role="group">
                      <button class="btn bg-danger-custom" ngbDropdownToggle>Columns</button>
                      <div ngbDropdownMenu class="ng-dropdown-panel-items p-1" style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                          <div class="form-group">
                              <div *ngIf="columnDefs" class="list-group ng-option">
                                  <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                                      <label class="list-group-item p-2">
                                          <input class="form-check-input me-1" type="checkbox" value="{{i}}" name="{{column.headerName}}" (change)="updateSelectedColumn($event)" [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                                          {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                                      </label>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!-- Grid Section -->
      <div class="row mb-0" style="min-height: 470px">
          <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
              <ag-grid-angular  [rowData]="rowData" (gridReady)="onGridReady($event)"    [defaultColDef]="defaultColDef" [columnDefs]="tableSelectedColumn" [enableCellTextSelection]=true (sortChanged)="onSortChange($event)" (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)" (filterOpened)="onFilterOpened($event)"  (rowClicked)="onRowClicked($event)" (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [paginationPageSize]="pageSize" [pagination]="true"  [rowSelection]="'single'" [suppressPaginationPanel]="true" style="width: 100%; height: auto;"></ag-grid-angular>
          </div>
      </div>

      <!-- Pagination Section -->
      <div class="row mt-0">
          <div class="col-4 col-xs-4">
              <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize" class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
                  <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
              </select>
          </div>
          <div class="col-8 col-xs-8">
              <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true" [collectionSize]="collectionSize" [maxSize]="maxSize" [pageSize]="pageSize" [rotate]="true" [ellipses]="ellipses" size="sm" class="d-flex justify-content-end align-right"></ngb-pagination>
          </div>
      </div>
  </div>
</div>
